import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CustomersListLayer from "./CustomersListLayer";

const CustomersListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Customers" />

        {/* CustomersListLayer */}
        <CustomersListLayer />
      </MasterLayout>
    </>
  );
};

export default CustomersListPage;
